import { ref } from 'vue'

export default () => ({
  id: ref(null),
  name: ref(null),
  surname: ref(null),
  fullName: ref(null),
  email: ref(null),
  phoneNumber: ref(null),
  languageId: ref(null),
  language: ref(null),
  settings: ref(null),
  roles: ref(null),
  isAuthenticated: ref(false),
  isVerified: ref(false),
  mfaMethods: ref([]),
  hasPasskeys: ref(false),
  // emailVerifiedAt: ref(null),
  createdAt: ref(null),
  updatedAt: ref(null)
})
